<template>
    <footer class="footer">
        <div class="container">
            <div class="content">
                <div class="row">
                    <div class="col-lg-2">
                        <div class="logo">
                            <img src="/app/images/logo/verozza-logo-simple.svg" :alt="getSnippets('Company')">
                        </div>
                        <ul class="social-list">
                            <li><a :href="getSnippets('Facebook')" target="_blank"><i class="fab fa-facebook fa-fw"></i></a></li>
                            <li><a :href="getSnippets('Instagram')" target="_blank"><i class="fab fa-instagram fa-fw"></i></a></li>
                            <li><a :href="getSnippets('Twitter')" target="_blank"><i class="fab fa-twitter fa-fw"></i></a></li>
                            <li><a :href="`https://www.linkedin.com/company/verozza-lighting`" target="_blank"><i class="fab fa-linkedin-in fa-fw"></i></a></li>
                            <li><a :href="`https://www.youtube.com/channel/UC5Akn1p_rseXq-1nmbGtFvw`" target="_blank"><i class="fab fa-youtube fa-fw"></i></a></li>
                        </ul>
                    </div>
                    <div class="col-lg-3">
                        <div class="headline">
                            {{ getSnippets('Navigation') }}
                        </div>
                        <ul class="navigation-list">
                            <li v-for="item in main" :key="item.page.id">
                                <router-link :to="{ path: item.slug }">{{ getBlockTranslation(item.page, 'title') }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3">
                        <div class="headline">
                            {{ getSnippets('Support') }}
                        </div>
                        <ul class="navigation-list">
                            <li v-for="item in footer" :key="item.id">
                                <router-link :to="{ path: item.slug }">{{ getBlockTranslation(item, 'title') }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-lg-3 offset-lg-1">
                        <div class="headline">
                            {{ getSnippets('Contact info') }}
                        </div>
                        <ul class="navigation-list">
                            <li class="info">
                                <a :href="getSnippets('Company maps')" target="_blank">
                                    <img src="/app/images/objects/icons/icon-map-white.svg" :alt="getSnippets('Company')">
                                </a>
                                <a :href="getSnippets('Company maps')" target="_blank">
                                    <span>{{ getSnippets('Company address') }}</span>
                                </a>
                            </li>
                            <li class="info">
                                <a :href="'mailto:' + getSnippets('Company email')" target="_blank">
                                    <img src="/app/images/objects/icons/icon-envelope-white.svg" :alt="getSnippets('Company')">
                                </a>
                                <a :href="'mailto:' + getSnippets('Company email')" target="_blank">
                                    <span>{{ getSnippets('Company email') }}</span>
                                </a>
                            </li>
                            <li class="info">
                                <a :href="'tel:' + getSnippets('Company phone')">
                                    <img src="/app/images/objects/icons/icon-phone-white.svg" :alt="getSnippets('Company')">
                                </a>
                                <a :href="'tel:' + getSnippets('Company phone')">
                                    <span>{{ getSnippets('Company phone') }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </footer>
</template>

<script>
    /* Mixins */
    import { Default } from '../../../mixins/Default'

    /* Logic */
    export default {
        name: "Footer",
        mixins: [Default],
        props: [
            'currency',
            'locality',
            'navigation',
            'snippets',
            'slugs',
            'translatable',
        ],
        data: function () {
            return {
                main: '',
                footer: ''
            }
        },
        methods: {
            fetchItems: function () {
                this.main = this.navigation.main
                this.footer = this.navigation.footer
            }
        },
        watch: {
            locality: function() {
                this.initialize()
                this.fetchItems()
            }
        }
    }
</script>
